/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react'

import PanoPlayer from '../PanoPlayer'
import { motion } from 'framer-motion'

import StartPanning from 'public/assets/svg/start_panning.svg'
import PausePanning from 'public/assets/svg/pause_panning.svg'
import Info from 'public/assets/svg/info.svg'
import EnterFullScreen from 'public/assets/svg/enter_full_screen.svg'
import ExitFullScreen from 'public/assets/svg/exit_full_screen.svg'
import styles from './styles'
import injectSheet from 'react-jss'
import compose from 'recompose/compose'
import ShareMenuContainer from '../../containers/ShareMenu'
import { sanitize } from 'dompurify'

const PanoViewer = props => {
    const { media, selectedIdx, changePanoFullScreen, inst_id, loc_id, classes } = props
    const [fullScreen, setFullScreen] = useState(false)
    const [play, setPlay] = useState(true)
    const [info, showInfo] = useState(false)
    const panoRef = useRef(null)

    const { id } = media[selectedIdx]
    const shareUrl = `${process.env.REACT_APP_BASE_URL}/tour/panoramas/${inst_id}/${loc_id}?id=${id}`

    useEffect(() => {
        setFullScreen(false)
        setPlay(true)
    }, [selectedIdx])

    const changeMode = () => {
        setPlay(!play)
    }

    const changeFullScreen = val => {
        setFullScreen(val)
    }

    const animations = {
        open: {
            x: '0%',
            transition: {
                ease: [0.28, 0.57, 0.2, 1],
                duration: 0.5,
            },
        },
        closed: {
            x: '100%',
            transition: {
                ease: 'easeIn',
                duration: 0.25,
            },
        },
    }

    return (
        <React.Fragment>
            <PanoPlayer
                ref={panoRef}
                fullScreen={fullScreen}
                changePanoFullScreen={changePanoFullScreen}
                play={play}
                changeMode={changeMode}
                changeFullScreen={changeFullScreen}
                options={{
                    hasEasy: media[selectedIdx]['hasEasy'],
                    height: '683',
                    width: '1341',
                    path: media[selectedIdx]['path'],
                    startFov: media[selectedIdx]['start_fov'],
                    startLat: media[selectedIdx]['start_lat'],
                    startLon: media[selectedIdx]['start_lon'],
                    exit_lat: media[selectedIdx]['exit_lat'],
                    exit_lon: media[selectedIdx]['exit_lon'],
                    autoRotateSpeed: 0.3,
                }}
                data-testid="pano"
            >
                <div className={classes.rightContainer}>
                    <div
                        className={classes.panning}
                        onClick={changeMode}
                        onKeyDown={changeMode}
                        role="button"
                        tabIndex={0}
                    >
                        {play ? <img src={PausePanning} /> : <img src={StartPanning} />}
                    </div>
                    <div
                        className={classes.fullScreenStyle}
                        onClick={() => {
                            changeFullScreen(!fullScreen)
                            changePanoFullScreen(!fullScreen)
                        }}
                        onKeyDown={e => {
                            if (e.code === 'Enter' || e.code === 'Space') {
                                changeFullScreen(!fullScreen)
                                changePanoFullScreen(!fullScreen)
                            }
                        }}
                        role="button"
                        tabIndex={0}
                    >
                        {fullScreen ? <img src={ExitFullScreen} /> : <img src={EnterFullScreen} />}
                    </div>
                </div>
                <div className={classes.imgText} data-testid="title">
                    {media[selectedIdx]['title']}
                </div>
                {media[selectedIdx]['description'] && (
                    <div className={classes.infoContainer}>
                        {!fullScreen && (
                            <div
                                className={classes.infoIcon}
                                onClick={() => showInfo(!info)}
                                onKeyDown={e => (e.code === 'Enter' || e.code === 'Space') && showInfo(!info)}
                                role="button"
                                tabIndex={0}
                                data-testid="info"
                            >
                                <img src={Info} />
                            </div>
                        )}
                        {info && (
                            <motion.div
                                initial={{ x: '100%' }}
                                animate={info ? 'open' : 'closed'}
                                variants={animations}
                                className={classes.infoPanel}
                            >
                                <span
                                    className={classes.infoDescription}
                                    data-testid="description"
                                    dangerouslySetInnerHTML={{
                                        __html: sanitize(media[selectedIdx]['description'], { ADD_ATTR: ['target'] }),
                                    }}
                                ></span>
                            </motion.div>
                        )}
                    </div>
                )}

                <div className={classes.shareMenu}>
                    <span
                        style={{
                            cursor: 'pointer',
                            position: 'absolute',
                            bottom: '0%',
                            right: '0%',
                        }}
                    >
                        <ShareMenuContainer url={shareUrl} className={classes.shareMenu} svgColor="#FFFFFF" />
                    </span>
                </div>
            </PanoPlayer>
        </React.Fragment>
    )
}

export default compose(injectSheet(styles))(PanoViewer)
